import React from 'react'

const Krishisalamaekdin = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. तल दिइएका अर्थ दिने शब्द पाठबाट खोजेर लेख्नुहोस्:</h5>
        <p>(क) सोच्न लायक : माननीय</p>
        <p>(ख) बालीनाली : उपज</p>
        <p>(ग) अर्थपूर्ण : सार्थक</p>
        <p>(घ) पानीमा बसेर जीविका गर्ने प्राणी : जलचर</p>
        <p>(ङ) विषयुक्त : विषादी</p>
        <p>(च) बिउ छरेपछि माटालाई पातपतिङ्गरले छोप्नु : आच्छादन</p>
        <p>(छ) एउटै स्थानमा पाँच फरक उचाइ हुने वृक्ष लगाउने : पञ्चस्तरीय ढाँचा</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुको अर्थ खुल्ने गरी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>गहुँत</strong>
        <p>हामीले गहुँत संकलन गरेर बारीमा मलको रूपमा प्रयोग गर्‍यौं।</p>
        <strong>उर्वर</strong>
        <p>चिसो र सिंचाइ सुविधा भएका कारण तराईका जमिनहरू उर्वर मानिन्छन्।</p>
        <strong>स्थलचर</strong>
        <p>हात्ती, गैंडा, र बाघ जस्ता जनावरहरू स्थलचर हुन्।</p>
        <strong>जलप्रबन्धन</strong>
        <p>सिचाइका लागि प्रभावकारी जलप्रबन्धन प्रणाली आवश्यक छ।</p>
        <strong>कृषिविद्</strong>
        <p>कृषिविद् डाक्टर राईले आधुनिक खेती प्रविधिबारे कृषकलाई प्रशिक्षण दिए।</p>
        <strong>प्रवर्धन</strong>
        <p>हामीले परम्परागत संस्कृतिको प्रवर्धनका लागि मेला आयोजना गर्‍यौं।</p>
        <strong>समृद्ध</strong>
        <p>शिक्षा, स्वास्थ्य र पूर्वाधारमा विकास भएमा राष्ट्र समृद्ध हुन्छ।</p>
        <strong>अभियन्ता</strong>
        <p>पर्यावरण संरक्षणका लागि धेरै अभियन्ताहरू सक्रिय भएका छन्।</p>
        <strong>महत्त्वाकाङ्क्षी</strong>
        <p>उसको महत्त्वाकाङ्क्षी योजना देशको विकासमा ठूलो योगदान पुर्‍याउन सक्छ।</p>
        <strong>ज्ञानशाला</strong>
        <p>विद्यालयको पुस्तकालयमा एउटा नयाँ ज्ञानशाला निर्माण गरिएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका पदावलीहरुको प्रयोग गरी एउटा अनुच्छेद तयार पार्नुहोस :</h5>
        <p>विकासका माध्यमबाट आफ्नो सामाजिक तथा आर्थिक अवस्था सुधार्न हामी नेपालीहरुले कृषि कर्ममा लाग्नुपर्छ । आजको कृषि प्रणाली परम्परागत हुनुहुँदैन । <strong>परम्परागत ज्ञान</strong>लाई आधुनिक प्रविधिसँग मिसाएर हामीले कृषि कार्यलाई एउटा उचाइमा पुर्‍याउनु पर्छ । राज्यले प्रत्येक स्थानीय तहमा एउटा कृषि क्याम्पस खोलेर प्रशस्त <strong>कृषि वैज्ञानिक</strong> तयार गर्नुपर्छ । कृषिकार्यमा हामीले <strong>रासायनिक मल</strong>को प्रयोग कम गर्दै <strong>प्राकृतिक वातावरण</strong> स्वच्छ हुने अनेक प्राकृतिक विरुवाहरु लगाउन जरुरी छ । यदि यसो गर्न सकेमा <strong>पर्यावरणको संरक्षणमा</strong> ठूलो टेवा मिल्ने थियो ।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. `कृषिशालामा एक दिन´ पाठ पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) संवादमा कतिजना पात्रहरु सहभागी छन् ?</h5>
        <p>= संवादमा ६ जना पात्रहरु सहभागी छन् ।</p>
        <h5>(ख) सबैभन्दा धेरै पटक प्रश्न गर्ने विद्यार्थी कुन हो ?</h5>
        <p>= सबैभन्दा धेरै पटक प्रश्न गर्ने विद्यार्थी म्हेन्दो हो ।</p>
        <h5>(ग) यो संवाद कुन स्थानमा गरिएको हो ?</h5>
        <p>= यो संवाद बद्री विश्वकर्मा कृषिशालाभित्र गरिएको हो ।</p>
        <h5>(घ) कुन पात्रले खाद्यपदार्थलाई औषधि भनेको छ ?</h5>
        <p>= डोल्मा गुरुमाले खाद्यपदार्थलाई औषधि भनेको छ ।</p>
        <h5>(ङ) सबैभन्दा छोटो संवाद कस्ले बोलेको छ ?</h5>
        <p>= सबैभन्दा छोटो संवाद हर्कध्वजले बोलेको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका भनाइहरु कसकसका हुन्, पत्ता लगाउनु होस् :</h5>
        <p>(क) बद्री विश्वकर्माको</p>
        <p>(ख) रामभरोसको</p>
        <p>(ग) डोल्मा गुरुमाको</p>
        <p>(घ) गुरुध्वजको</p>
        <p>(ङ) भगतसिंहको</p>
        <p>(च) डोल्मा गुरुमाको</p>
      </div>
      <hr/>
      <div>
        <h5>४. पाठमा रहेको `मैले प्रयोग……..हैन र ?´संवादांश पढी दिइएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) के गर्दा जमिन उर्वर बन्छ ?</h5>
        <p>= रासायनिक मल र विषादीको प्रयोग नगरी घरमै निर्माण गरेको कम्पोस्ट मल तथा विषादीका रुपमा गहुँतको प्रयोग गर्दा जमिन उर्वर बन्छ ।</p>
        <h5>(ख) पानीको स्रोत विषाक्त हुनाको कारण के हो ?</h5>
        <p>= पानीको स्रोत विषाक्त हुनाको कारण रासायनिक मल तथा विषादीहरुको अत्याधिक प्रयोग हो ।</p>
        <h5>(ग) संवादमा के कर्मलाई अपराध भनिएको छ ?</h5>
        <p>= संवादमा खेतमा अत्याधिक रासायनिक मल तथा विषादीको प्रयोग गरी प्राणीहरुको जीवन रक्षाको आदर्शलाई भुल्ने कर्मलाई अपराध भनिएको छ ।</p>
        <h5>(घ) प्रकृतिले हामीलाई कसरी सजाय दिइराखेको छ ?</h5>
        <p>= प्रकृतिले हामीलाई अनेक प्रकारका रोगहरु उब्जाएर सजाय दिइराखेको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको संवादांश पढ्नुहोस् र सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) प्राकृतिक खेती गर्दा के फाइदा हुन्छ ?</h5>
        <p>= प्राकृतिक खेतीले कीटनाशकहरू प्रयोग कम गर्छ, माटोको क्षय घटाउँछ, नाइट्रेट जमिनको पानी र सतहको पानीमा कम गर्छ, र पशु फोहोरलाई खेतमा पुन: प्रयोग गर्दछ । प्राकृतिक खेती गर्दा किसानको पैसा बजार जाँदैन । यसका लागि किसानले उत्पादन कार्यका लागि केही पनि किन्दैन तर उत्पादित अन्नबाली भने बेचिरहन्छ । प्राकृतिक खेती उत्पादनमा लागत कम छ तर उत्पादित वस्तुको मूल्य चाहिँ धेरै पाइन्छ । जलवायु परिवर्तन र बढ्दो विश्व जनसङ्ख्याका चुनौतीहरू सामना गर्दै भविष्यको प्राकृतिक कृषिको चुनौती यसको वातावरणीय फाइदाहरू कायम राख्नु, उत्पादन वृद्धि र मूल्य घटाउनु हुनेछ ।</p>
        <h5>(ख) "मन परेको काममा कमाइ थोरै भए पनि चित्त बुझ्छ ।" यस कथनलाई पुष्टि गर्नुहोस् ।</h5>
        <p>= मानिसको काम गर्ने कुरा इच्छा, चाहना र सन्तुष्टिसँग जोडिएको हुन्छ । त्यस्तो काम गर्दा जोस, जाँगर त हुन्छ नै साथमा थकानको पनि कमै महसुस हुन्छ । उ जस्तोसुकै समयमा पनि गर्न सक्दछ । आफ्नो चाहना अनुसारको काम छ भने त्यसमा रमाएर काम गर्छ । रमाएर गरेको काम सफल पनि हुन्छ । मन परेको काममा रमाउने मान्छे श्रमको मूल्य पैसामा तुलना गरी कहिल्यै दुःखी हुँदैन । कमाइ थोरै नै भए पनि सुख सन्तोषको अनुभूति गर्छ । त्यसैले मन परेको काममा थोरै कमाइ भएपनि आत्मसन्तुष्टि मिल्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको संवादांश पढ्नुहोस् र सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) हाम्रो मौलिक बिउबिजन कसरी जोगाउन सकिन्छ ?</h5>
        <p>नेपाल एक कृषि पराधीन देश हो । राष्ट्रको दुई-तिहाइ जनसङ्ख्याले अपनाउने कृषि पेसालाई राष्ट्रले सम्मानित बनाइ कृषि रणनीति अपनाउनुपर्छ । जैविक विविधताको संरक्षण गरी मौलिक विउविजको प्रयोगमा जोड दिँदै हाम्रा अथाह खाद्यान्नका आधारहरु लोप हुनवाट जोगाउनुपर्छ । परम्परागत ज्ञान र अनुभवलाई जोगाउँदै विउविजनको संरक्षण र प्रवर्द्धन गर्नुपर्छ । सरकाले युवा पुस्ताका लागि कृषि क्षेत्रमा लाग्न सीप एवं तालिम प्रदान गरी अनुदानको व्यवस्था गर्नुपर्दछ । कृषि उपजको बजार ब्यवस्थापन गरी हौसला प्रदान गर्नुपर्दछ । अतः मौलिक बिउबिजनद्वारा उत्पादित उत्पादनको म्यादस्थापन गर्न सके हाम्रो मौलिक बिउबिजन जोगाउन सकिन्छ ।</p>
        <h5>(ख) कृषिकर्मलाई सम्मनित कर्मका रुपमा स्थापित गर्न के के गर्नुपर्ला ?</h5>
        <p>= कृषिकर्म मानव जीवनको आधारभूत आवश्यकता पूर्ति गर्ने महत्वपूर्ण क्षेत्र हो। त्यसैले यसलाई सम्मानित कर्मका रूपमा स्थापित गर्न राज्य, समाज र प्रत्येक नागरिकको सक्रिय भूमिका आवश्यक हुन्छ। कृषिकर्मलाई सम्मानित बनाउन निम्न उपायहरू अपनाउन सकिन्छ:
</p><p>
1. युवापुस्तालाई कृषि क्षेत्रमा आकर्षित गर्ने कार्यक्रमहरू सञ्चालन गर्नुपर्छ र उनीहरूलाई आधुनिक कृषि प्रविधिबारे जानकारी दिनुपर्छ।
</p><p>
2. सरकारले कृषि क्षेत्रको बजेटमा वृद्धि गरी पूर्वाधार, सिंचाइ, बीउ, मल आदि क्षेत्रमा लगानी बढाउनुपर्छ।
</p><p>
3. कृषकहरूलाई प्राविधिक तालिम, कृषि मेलाहरू, तथा सहकारी कार्यक्रमहरू मार्फत हौसला र सीप प्रदान गर्नुपर्छ।
</p><p>
4. कृषि उपजको उचित मूल्य निर्धारण, बजार व्यवस्थापन र निर्यात प्रवर्धनका लागि नीतिगत व्यवस्था गर्नुपर्छ।
</p><p>
5. कृषि शिक्षालाई प्राथमिकता दिँदै कृषि विद्यालय तथा विश्वविद्यालय स्थापना गर्नुपर्छ जसले स्वरोजगारको अवसर सिर्जना गर्छ।
</p><p>
6. कृषि विमाको व्यवस्था गरी प्राकृतिक प्रकोप वा क्षतिको अवस्थालाई सम्बोधन गर्नुपर्छ।
</p><p>
यसरी सम्पूर्ण पक्षको सहकार्यद्वारा कृषिकर्मलाई सम्मानित, सुरक्षित र आकर्षक पेसा बनाइ आत्मनिर्भर राष्ट्र निर्माण गर्न सकिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. उत्तर लेख्नुहोस् :</h5>
        <h5>(क) कृषिकर्म किन मानवजातिको अस्तित्वसँग गाँसिएको छ ?</h5>
        <p>= मानव जातिको अस्तित्व नै कृषिमा आधारित छ । कृषिबाट अन्न उत्पादन नगर्ने हो भने मानव जीवित रहन सक्दैन । मानव जातिलाई जीवन दिने र युगौयुगसम्म मानव जातिको विकासका लागि कृषि कर्म अनिवार्य छ । मानिसको बाच्ने आधार कृषिबाट उत्पन्न वस्तुहरु हुन् । मानव मात्रै होइन, संसारका सबै प्राणी कुनै न कुनै रुपमा कृषिमै आश्रित हुन्छन् । वैज्ञानिकहरुले जबसम्म नखाइकन बाच्न सक्ने प्रविधिको विकास गर्दैनन्, तबसम्म मानवको अस्तित्व कृषि कर्ममा नै अडिएको हुन्छ ।</p>
        <h5>(ख) वनजङ्गल र कृषिको सम्बन्ध कस्तो छ?</h5>
        <p>= वनजङ्‌गल र कृषि एक अर्काका उपकारक बनेका हुन्छन् । वनजङ्गलका पात पतिङ्‌गरबाट कृषिले आवश्यक मल प्राप्त गर्छ भने कृषिमा गरिएको सिचाइवाट वनले पनि सिचाइ प्राप्त गर्छ । एउटा विरुवाले फ्याकेको मल अर्को विरुवाले ग्रहण गर्छ । वनभङ्गलका विरुवाहरुबाट निस्किएका बास्नाले कृषि बालीमा रोग लाग्दैन । गाईवस्तुले नखाने वनजङ्गलका पातहरूबाट कृषिका लागि औषधिबताउन सकिन्छ । यसै गरि कृषिका अन्नपात कुहिएर वनजङ्गलले पोषण प्राप्त गर्छ, त्यसैले वनजङ्गल र कृषिको सह अस्तित्व देखा पर्छ ।</p>
        <h5>(ग) जैविक मल र औषधि कसरी बनाउन सकिन्छ ?</h5>
        <p>= जैविक मल घरायसी सामग्रीहरुको प्रयोग गरी सजिलै बनाउन सकिन्छ । एउटा ठूलो भाडोमा दुईसय लिटर पानी, दश लिटर गहुँत, दश किलो गोबर, एक किलो गुँड, एक किलो दालको पिठो र वरपिपलको फेदको एक मुठी माटो राम्रोसँग मिसाएर तिन दिनसम्म ढाकेर राख्ने अनि विहान बेलुका लौराले चलाउनुपर्छ । तिन दिनपछि जैविक मल प्रयोग गर्नका लागि तयार हुन्छ । साथै गाईवस्तुले नखाने खालका दस बाह प्रकारका रुखका पातहरु र गहुत मिलाएर त्यसमा खोसार्नी, लसुन, वेसार, वोझो जस्ता जडीवुटी मिसाएर जैविक औसधि बनाउन सकिन्छ ।</p>
        <h5>(घ) आच्छादन प्रक्रियाका फाइदाहरु बताउनुहोस् ।</h5>
        <p></p>
        <h5>(ङ) कृषि कर्मका बारेमा तपाईका विचारहरु प्रस्तुत गर्नुहोस् ।</h5>
        <p>= कृषिकर्म मानव जातिको अस्तित्वको आधारभूत स्रोत हो। मानव जीवनको निरन्तरताका लागि आवश्यक अन्न, फलफूल, तरकारी, दाल, मासु, दूधजस्ता पोषक पदार्थ कृषिबाट नै प्राप्त हुन्छन्। यदि कृषिबाट अन्न उत्पादन नहुने हो भने मानिसले बाँच्न सक्दैन।</p>
        <p>कृषि मानव मात्र नभई समस्त जीवसृष्टिको जीवनसँग प्रत्यक्ष रूपमा जोडिएको क्षेत्र हो। संसारका अधिकांश प्राणी प्रत्यक्ष वा अप्रत्यक्ष रूपमा कृषिप्रति निर्भर छन्। जबसम्म मानिसले बिना खादा बाँच्न सक्ने प्रविधिको विकास गर्दैन, तबसम्म कृषि नै मानव अस्तित्वको मेरुदण्ड रहन्छ।
        </p>
        <p>
यसैले कृषिकर्म मानव जातिको अस्तित्वसँग मात्र होइन, समग्र जीवन प्रणालीसँग गहिरो रूपमा गाँसिएको अनिवार्य कर्म हो।</p>
      </div>
      <hr/>
      <div>
        <h5>८. समीक्षात्मक उत्तर दिनुहोस :</h5>
        <h5>(क) दिगो कृषि पद्धतिका लागि के कस्ता कुरामा ध्यान पुर्‍याउनु पर्छ ?</h5>
        <p>= नेपाल कृषि प्रधान देश हो र यहाँको अधिकांश जनसंख्या प्रत्यक्ष या अप्रत्यक्ष रूपमा कृषिमा निर्भर छ। तर विडम्बना, यहाँ कृषिकर्मलाई अझै पनि परम्परागत, श्रमप्रधान र कम उत्पादनशील पेसाको रूपमा लिइन्छ। ‘कृषिशालामा एक दिन’ नामक पाठमा कृषि क्षेत्रको वर्तमान अवस्था, समस्याहरू र त्यसको दिगो समाधानका उपायहरूबारे गम्भीर विश्लेषण गरिएको छ। यो पाठले कृषिको दीर्घकालीन विकासका लागि नीति, प्रविधि, समाज र सरकारले ध्यान दिनुपर्ने मुख्य पक्षहरू प्रस्तुत गरेको छ।</p>
        <p>दिगो कृषि भन्नाले त्यस्तो कृषि प्रणाली बुझिन्छ, जसले उत्पादनको निरन्तरता मात्र नभई पर्यावरणीय संरक्षण, सामाजिक न्याय र आर्थिक समृद्धिलाई समेत सुनिश्चित गर्छ। दिगो कृषिका लागि सबैभन्दा पहिले सरकारले भू–प्रकृति, जलवायु, र जैविक विविधताको संरक्षणलाई प्राथमिकता दिनु अत्यावश्यक छ। विभिन्न भौगोलिक क्षेत्रअनुसार फरक–फरक खेती प्रणाली अपनाउने नीति ल्याउनुपर्छ। एकै प्रकारको नीति सबै क्षेत्रमा लागू गर्नु उपयुक्त हुँदैन।दिगो कृषि पद्धतिको अर्को आधार हो, परम्परागत ज्ञान र अनुभवको संरक्षण तथा उपयोग। नेपाली कृषकले पुस्तौंदेखि गर्दै आएको खेतीपातीका परम्परागत तरिकामा थुप्रै ज्ञान र सीपहरू छन्, जसलाई वैज्ञानिक अध्ययनद्वारा सुधार र आधुनिकीकरण गरेर प्रयोगमा ल्याउन सकिन्छ। त्यसका लागि अनुसन्धान केन्द्र, कृषि विश्वविद्यालय र विज्ञ व्यक्तिहरूको सक्रिय भूमिका हुनुपर्छ।</p>
        <p>यसबाहेक, कृषिमा नयाँ प्रविधिको प्रयोग दिगोपनको अर्को महत्वपूर्ण पक्ष हो। जैविक मल, सिँचाइको वैज्ञानिक प्रणाली, रोग प्रतिरोधात्मक बिउ, र आधुनिक उपकरणको प्रयोगले उत्पादन वृद्धिसँगै माटो र जल स्रोतको संरक्षण पनि गर्न सकिन्छ। रासायनिक मलको अत्यधिक प्रयोगले जमिनको उर्वरता घटाउने भएकाले वैकल्पिक उपायहरू अवलम्बन गर्नुपर्छ।दिगो कृषि प्रणालीको सफल कार्यान्वयनको लागि मानव संसाधन विकास पनि अत्यन्तै आवश्यक छ। त्यसका लागि युवापुस्तालाई कृषितर्फ आकर्षित गर्नुपर्ने आवश्यकता छ। आजका धेरै युवा विदेश पलायन भइरहेका छन्, किनकि उनीहरूले कृषिमा भविष्य देख्दैनन्। कृषिमा सम्मान, आधुनिकता, प्रविधि र प्रतिफल देखिए मात्र उनीहरू यस पेसातर्फ आकर्षित हुन्छन्। त्यसैले, कृषि क्षेत्रमा स्वरोजगार, स्टार्टअप, उद्यमशिलता, सहकारी प्रणाली र व्यावसायिक तालिमको विकास गर्नुपर्छ।</p>
        <p>साथै, कृषकको जीवनस्तर उठाउनका लागि बीमा, अनुदान, कर्जाको सहज पहुँच, बजार व्यवस्थापन, मूल्य स्थिरता र सरकारी संरक्षणको व्यवस्था अनिवार्य छ। सरकारले नीति मात्र बनाउनु होइन, तिनको प्रभावकारी कार्यान्वयन सुनिश्चित गर्नु जरुरी छ। बजारमा हुने विचौलियाको नियन्त्रण, किसानको सिधा पहुँच बजारमा कायम गरिनुपर्छ। दिगो कृषिका लागि सबै पक्षको सहभागिता आवश्यक छ। नीति निर्माता, वैज्ञानिक, कृषि अभियन्ता, स्थानीय सरकार, र कृषकहरू सबैले आ–आफ्नो भूमिकामा सजग, जिम्मेवार र सकारात्मक रहनुपर्छ। एक जना वा एउटै संस्था मात्रैले दिगो कृषि सम्भव बनाउँदैन, बरु यो साझा प्रयासद्वारा मात्र सम्भव हुन्छ।</p>
        <p>अन्ततः, ‘कृषिशालामा एक दिन’ नामक पाठले कृषिलाई समृद्ध र दिगो पेसा बनाउन हामीले गर्ने प्रयास, सोच, नीति र कार्यान्वयनको स्तर कस्तो हुनुपर्छ भन्ने कुरा उजागर गरेको छ। कृषिमा भविष्य देख्ने सोच र सोचलाई कार्यान्वयनमा रूपान्तरण गर्ने संकल्प भए मात्र दिगो कृषि सम्भव हुन्छ।  </p>
      </div>
      <hr/>
      <div>
        <h5>(ख) "वातावरण प्रदुषणको मूल कारण मान्छे नै भएकाले यसको समाधान पनि मानिसले नै गर्नुपर्छ ।" संवादांत्मक सन्दर्भ समेत ख्याल गरी आफ्ना तर्कहरु प्रस्तुत गर्नुहोस् ।</h5>
        <p>= वातावरण प्रदूषण भन्नाले प्राकृतिक तत्त्वहरू जस्तै हावा, पानी, माटो, ध्वनि, ताप आदिमा हुने अस्वाभाविक तथा हानिकारक परिवर्तनलाई जनाइन्छ। आज विश्वभर वातावरणीय सन्तुलनमा गम्भीर समस्या उत्पन्न भएको छ, जसको प्रमुख कारण मानवीय क्रियाकलाप हुन्। अन्धाधुन्ध वन फडानी, औद्योगिक फोहोर, सवारी साधनको धुँवा, प्लास्टिकको अत्यधिक प्रयोग, र रासायनिक मल तथा कीटनाशकको अत्यधिक प्रयोग जस्ता मानवीय गतिविधिले आजको पृथ्वीलाई प्रदूषित बनाइरहेको छ। मानिसले नै प्रकृतिको स्वरूपमा हस्तक्षेप गरेपछि अहिले हामी जलवायु परिवर्तन, जैविक सन्तुलनको विघटन, ओजन तहको पातलोपन र अत्यधिक तापमान वृद्धिको सामना गरिरहेका छौँ।</p>
        <p>वातावरण प्रदूषणको जरो नै मानव भएकोले यसको समाधान पनि मानिसबाटै सम्भव छ। समाधानका लागि सबैभन्दा पहिले मानिसको सोच, प्रवृत्ति र जीवनशैलीमा परिवर्तन ल्याउनु आवश्यक छ। एकातिर आधुनिक प्रविधि प्रयोग गर्दा अर्कोतिर त्यसको असर सोच्न जरुरी छ। वृक्षरोपण, जैविक कृषि प्रवर्द्धन, जल स्रोतको संरक्षण, फोहोर व्यवस्थापन, नवीकरणीय ऊर्जा प्रयोग जस्ता उपायलाई आत्मसात् गर्नुपर्छ। साथै, दिगो विकासको अवधारणा अनुरूप वातावरणमैत्री योजना र नीति अपनाई कार्यान्वयन गर्न आवश्यक छ। विद्यालयदेखि समाजसम्म जनचेतना फैलाउनु, वातावरणीय शिक्षा दिनु र सामूहिक पहलमार्फत प्रदूषण घटाउनु आजको आवश्यकता हो।</p>
        <p>यसरी हेर्दा वातावरण प्रदूषण कुनै स्वतःस्फूर्त समस्या होइन, यो मानवले सिर्जना गरेको गम्भीर समस्या हो। तसर्थ, यसको समाधानको दायित्व पनि मानव आफैँले लिनुपर्छ। हामीले प्रकृति प्रतिको जिम्मेवारी बुझेमा मात्र भविष्य सुरक्षित हुनेछ। समयमै सचेत भइ आजैबाट हरित अभियानमा लागेमा स्वच्छ, स्वस्थ र समुन्नत जीवन सम्भव छ। वातावरण जोगाउनु भनेको आफैँलाई बचाउनु हो भन्ने चेत सबैमा फैलाउनु अत्यन्तै जरुरी छ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस्:</h5>
        <h5>(क) नेपालले कस्तो वाणिज्य नीति अवलम्बन गरेको छ ?</h5>
        <p>= नेपालले अन्तरास्ट्रियस्तरमा प्रतिस्पर्धा गर्ने र व्यापार व्यवसायको प्रवर्धन गर्ने उदेश्य लिएर आफ्नै स्रोतसाधनको प्रयोग गरी आर्थिक विकास र गरिबी निवारणको वाणिज्य नीति अवलम्बन गरेको छ ।</p>
        <h5>(ख) राजस्वमा वृद्धि कसरी गर्न सकिन्छ ?</h5>
        <p>= राजस्वमा वृद्धि लघु, घरेलु उद्योगलाई प्रोत्साहित गर्दै नेपाली माटो सुहाउँदो अर्थतन्त्र निर्माणतिर लगेर गर्न सकिन्छ ।</p>
        <h5>(ग) देशको समृद्धिमा निजी क्षेत्रको भुमिका कस्तो हुन्छ ?</h5>
        <p>= निजी क्षेत्रले आफ्नै देशमा रोजगार सिर्जना गर्न सक्ने र राज्यको अर्थव्यवस्थालाई मजबुद बनाउने भएकाले देशको समृद्धिमा निजी क्षेत्रको महत्त्वपूर्ण भुमिका हुन्छ।</p>
        <h5>(घ) `जैविक विविधता र गरिबी निवारण ´पदावलीको अर्थ लेख्नुहोस् ।</h5>
        <p>= जैविक विविधता : जीवनको विविधतामय अस्तित्व</p>
        <p>गरिबी निवारण : गरिबी हटाउने कार्य</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. दिइएको गद्यांशमा रेखाङ्कन गरिएका पदावलीलाई एउटै समस्त शब्द बनाई लेख्नुहोस् :</h5>
        <p>भानिज दाइ - भान्दाइ</p>
        <p>वाद र विवाद - वादविवाद</p>
        <p>प्रत्येक दिन - प्रतिदिन</p>
        <p>रोगले ग्रस्त - रोगग्रस्त</p>
        <p>लोकको हित - लोकहित</p>
        <p>अन्न र जल - अन्नजल</p>
        <p>प्रत्येक वर्ष - प्रतिवर्ष</p>
        <p>गाउँको पालिक - गाउँपालिका</p>
        <p>हिमको आलय - हिमालय</p>
        <p>जीवनरुपी गीत - जीवनगीत</p>
        <p>कूपको मण्डुक - कूपमण्डुक</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएको अनुच्छेदका गाढा शब्दलाई विग्रह गरी देखाउनुहोस् :</h5>
        <p>सान्नानी - सानी नानी</p>
        <p>पूजासाम्रागी - पूजाका लागि साम्रागी</p>
        <p>पीताम्बर - पीत छ अम्बर जसको</p>
        <p>बाघचाल - बाघको चाल</p>
        <p>नियमपूर्वक - नियम पूर्वक</p>
        <p>आजभोलि - आज भोलि</p>
        <p>धर्मकर्म - धर्म र कर्म</p>
        <p>चक्रपाणि - चक्र छ पाणिमा जसको</p>
        <p>दोधार - दुई धारको समूह</p>
        <p>चौबन्दी - चार बन्दीको समूह</p>
        <p>माखिबुट्टे - माखाको जस्तो बुट्टा भएको</p>
        <p>पञ्चामृत - पाँच अमृतको समूह</p>
        <p>फूलपाती - फूल र पाती</p>
        <p>सयपत्री - सय पत्र छन् जसका</p>
        <p>लालुपाते - लाल छ पात जसको</p>
        <p>पल्लाघर - पल्लो घर</p>
        <p>नीलकण्ठ - नील छ कण्ठ जसको</p>
        <p>षड्दर्शन - छ दर्शनको समूह</p>
        <p>अष्टाध्यायी - आठ अध्यायहरुको समूह</p>
      </div>
      <hr/>
      <div>
        <h3>३. पाठबाट समस्त शब्द खोज्नुहोस् र ती शब्द कसरी बनेका हुन् , बताउनुहोस् :</h3>
        <p>भाइबहिनी - भाइ र बहिनी</p>
        <p>स्नातकोत्तर - स्नातक उत्तर</p>
        <p>पढेलेखेको - पढेको लेखेको</p>
        <p>यतातिर - यता तिर</p>
        <p>महत्वाकाङ्क्षी - महत्व आकाङ्क्षी</p>
        <p>कृषिकर्म - कृषिको कर्म</p>
        <p>फलफूल - फल र फूल</p>
        <p>वरपिपल - वर र पिपल</p>
        <p>गाईवस्तु - गाई र वस्तु</p>
        <p>बोटविरुवा - बोट र बिरुवा</p>
        <p>खेतबारी - खेत र बारी</p>
        <p>खाद्यपदार्थ - खाद्य पदार्थ</p>
      </div>
      <hr/>
      <div>
        <h5>४. समस्त शब्द भए विग्रह अनि विग्रहका अवस्थामा भए समस्त शब्द बनाउनुहोस् :</h5>
        <p>महाकवि - महान कवि</p>
        <p>बाछिटा - बाङ्गो छिटा</p>
        <p>फेदनटुप्पो - न फेद न टुप्पो</p>
        <p>नवरस - नौ रसको ससमूह</p>
        <p>दाजुभाइ - दाजु र भाइ</p>
        <p>हाडेओखर - हाड जस्तो ओखर</p>
        <p>हृष्टपुष्ट - हृष्ट र पुष्ट</p>
        <p>ऋणनधन - न ऋण न धन</p>
        <p>सप्तमातृका - सात मातृकाको समूह</p>
        <p>बाढीपीडित - बाढीले पीडित</p>
        <p>चौपाया - चार पाउ भएको</p>
        <p>चरिनङ्ग्रे - चराको जस्तो नङ्ग्रा भएको</p>
        <p>जुँगामुठा - मुठा जत्रा जुँगा भएको</p>
        <p>बोकेदारी - बोकाको जस्तो दारी छ जसको</p>
        <p>चन्द्रबिन्दु - चन्द्र जस्तो बिन्दु</p>
        <p>लमकन्ना - लामा कान छन् जसका</p>
        <p>कालीमाटी - कालो माटो भएको</p>
        <p>लम्बोदर - लम्ब उदर भएको</p>
        <p>लामखुट्टे - लामा खुट्टा भएको</p>
        
      </div>
    </div>
  )
}

export default Krishisalamaekdin
